<template>

    <div>

        <div class="row row-cols-1 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Banner') }}</legend>
                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                            <textarea-input label="description" v-model="form.description" :error="form.errors.description" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Zones') }}</legend>
                            <multi-select-input
                                v-model="form.zones"
                                value-consists-of="ALL"
                                value-format="object"
                                :flat="true"
                                sort-value-by="INDEX"
                                :multiple="true" 
                                :always-open="false"
                                :options="zoneOptions" 
                                :placeholder="__('Search zones')" 
                                :error="form.errors.zones"
                                />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Code') }}</legend>
                            <textarea-input label="html_code" v-model="form.html_code" :error="form.errors.html_code" rows="20" class-name="text-nowrap font-monospace" />
                            <textarea-input label="js_code" v-model="form.js_code" :error="form.errors.js_code" rows="10" />
                            <textarea-input label="css_code" v-model="form.css_code" :error="form.errors.css_code" rows="10" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="banner">
                    {{ __('Löschen') }}
                </button>
            </div>

        </div>

    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';

    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'banner',
            'zones',
        ],
        data() {
            return {
                zoneOptions: this.zones,
            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            MultiSelectInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.banners.destroy', this.banner));
                }
            },
        },
    }
</script>
